import SCounter from './SCounter.vue';
import Vue from 'vue';
import { DirectiveOptions } from 'vue/types/options';

interface ICounterComponent extends SCounter {
  id?: number;
  count: string;
  type: {[key: string]: boolean};
}

const CounterConstructor = Vue.extend(SCounter);

const Counter: ICounter = ({ count, type, element }) => {
  const id = Counter.id++;
  const options = {
    type,
    count,
    element,
    id,
  };
  const instance = (new CounterConstructor({
    propsData: options,
  }) as ICounterComponent);
  instance.$mount();
  if (element) element.appendChild(instance.$el);
  Counter.instances.push(instance);
  return instance;
};

// eslint-disable-next-line no-array-constructor
Counter.instances = [];
Counter.id = 0;
Counter.instance = id => Counter.instances.find(counter => counter.id === Number(id));

export default Counter;

export interface ICounter {
  ({ count, type, element }:
    {count?: string | number | null; type?: object | null; element: HTMLElement}):
      ICounterComponent;
  instances: ICounterComponent[];
  id: number;
  instance: (id: string | undefined) => ICounterComponent | undefined;
}

export const CounterDirective: DirectiveOptions = {
  bind: (el, binding) => {
    const data = {
      element: el,
      count: binding.value,
      type: binding.modifiers,
    };
    const instance = Counter(data);
    el.dataset.id = String(instance.id);
  },
  update: (el, binding) => {
    const instance = Counter.instance(el.dataset.id);
    if (instance) {
      instance.count = binding.value;
      instance.type = binding.modifiers;
    }
  },
  unbind: el => {
    const instance = Counter.instance(el.dataset.id);
    if (instance) instance.$destroy();
  },
};
